import {useMemo} from 'external/react'

import usePayment from 'context/payment-context/hook'

import LanguageBar from './LanguageBar'
import Subject from './Subject'
import usePublic from 'context/public-context/hook'

export default function Subjects () {

	const {cart} = usePayment()
	const {offerData: {basic, elective}, params: { typeSubject, offerId }, query} = usePublic()
	
    const languageId = useMemo(() => query.languageId || 'es', [query.languageId])

	const subjects = useMemo(() => {
        const selectedSubjects = (cart.properties[typeSubject] || []).filter(id => id).map(id => id.substring(0,2))
		const target = (typeSubject === 'basic' ? basic : elective) || []
		return target.map(subject => {
			const {id, color} = subject
			const name = subject.name[languageId] 
			const courses = subject[`units_${languageId}`] || 0
			const selected = typeSubject === 'basic' ? selectedSubjects.indexOf(id) >= 0 : selectedSubjects.length === 3
			return {idSubject: id, languageId, color, name, courses, selected, offerId}
		}).filter(({courses}) => courses > 0)
	}, [cart.properties, languageId, typeSubject, basic, elective, offerId])

	return (
		<div className='container_container'>
			<h2 className='title_subject'>
				Selecciona una materia en inglés o español para elegir un curso
			</h2>
			<div className='body_subject'>
				<LanguageBar />
			<div className='body_list'>
				{subjects.map((subject, index) => <Subject key={index} {...subject} />)}
			</div>
			</div>
		</div>
	)
}